<template>

    <router-view/>
</template>

<style lang="scss">

@font-face {
  font-family: 'Frutiger';
  src: url('~@/assets/font/Frutiger.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

#app {
    font-family: Frutiger, Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #b7c5d3;
    width: 100%;
    height: 100%;
}

html, body {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
}
</style>
